/**
 * Display helpers for the Goal-Setting Meeting time picker. Availability
 * itself comes from the booking API; nothing here invents times.
 */

/** Group slots by calendar day for the picker UI. */
export function groupSlotsByDay(slots = []) {
  const groups = [];
  const indexByDay = new Map();

  slots.forEach((slot) => {
    const key = slot.dayKey;
    if (!indexByDay.has(key)) {
      indexByDay.set(key, groups.length);
      groups.push({
        dayKey: key,
        dayLabel: formatDayLabel(new Date(slot.startsAt)),
        slots: [],
      });
    }
    groups[indexByDay.get(key)].slots.push(slot);
  });

  return groups;
}

export function formatSlotLabel(date) {
  return new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
}

export function formatDayLabel(date) {
  return new Intl.DateTimeFormat(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }).format(date);
}

export function formatConfirmLabel(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  return new Intl.DateTimeFormat(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
}
